/** @jsx jsx */
import { jsx } from '@emotion/core';

import { maybePrettyJsonString } from 'app/developer-v3/utils';

import BundleConsoleBase from '../BundleConsoleBase';

type Log = {
  date: string;
  id: string;
  input: string;
  message: string;
};

type Props = {
  isLoading: boolean;
  logs: Log[];
  onClickTestAgain: () => void;
};

function Bundle(props: Props) {
  return (
    <BundleConsoleBase
      isLoading={props.isLoading}
      logs={props.logs.map(({ date, id, input, message }) => ({
        date,
        id,
        message: maybePrettyJsonString(input),
        title: message,
      }))}
      onClickTestAgain={props.onClickTestAgain}
    />
  );
}

Bundle.defaultProps = {
  isLoading: false,
  logs: [],
};

export default Bundle;
